import React from 'react';
import { Box, Typography, Avatar, Chip, Alert } from '@mui/material';
import { Flag as FlagIcon, Circle as CircleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

export default function ModerationWarningNotificationCard({ notification, onMarkRead }) {
  const navigate = useNavigate();
  const payload = notification.payload || {};

  const handleClick = () => {
    if (!notification.is_read && onMarkRead) onMarkRead();
    if (payload.target_type === 'call' && payload.target_id) {
      navigate(`/funding/call/${payload.target_id}`);
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        py: 1.25,
        px: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        backgroundColor: notification.is_read ? 'transparent' : '#fff8e1',
        cursor: payload.target_id ? 'pointer' : 'default',
        transition: 'background-color 0.2s',
        '&:hover': { backgroundColor: 'action.selected' },
      }}
    >
      {/* Header row */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
        <Avatar sx={{ width: 32, height: 32, bgcolor: 'warning.main', flexShrink: 0 }}>
          <FlagIcon sx={{ fontSize: 18 }} />
        </Avatar>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" fontWeight={700} color="warning.dark">
              Your comment was flagged
            </Typography>
            <Chip
              label="Moderation"
              size="small"
              color="warning"
              variant="outlined"
              sx={{ height: 18, fontSize: 10, flexShrink: 0 }}
            />
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexShrink: 0 }}>
          <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
            {formatDistanceToNow(new Date(notification.created), { addSuffix: true })}
          </Typography>
          {!notification.is_read && (
            <CircleIcon sx={{ fontSize: 8, color: 'warning.main' }} />
          )}
        </Box>
      </Box>

      {/* Reason — the most important part */}
      <Alert
        severity="warning"
        icon={false}
        sx={{ py: 0.75, px: 1.25, borderRadius: 1, '& .MuiAlert-message': { p: 0 } }}
      >
        <Typography variant="body2" fontWeight={600} sx={{ mb: 0.25 }}>
          Reason:
        </Typography>
        <Typography variant="body2">
          {payload.message ||
            'Your comment did not meet the community guidelines for this funding call.'}
        </Typography>
      </Alert>

      {payload.target_type === 'call' && (
        <Typography variant="caption" color="primary.main" sx={{ mt: 0.75, display: 'block' }}>
          Click to view the funding call →
        </Typography>
      )}
    </Box>
  );
}
